<template>
	<div class="minhas-adesoes-listagem">
		<v-data-table
			id="idAcessarMinhasAdesoesListagem"
			v-if="hasItens"
			:headers="colunas"
			:items="itens"
			item-key="id"
			:server-items-length="totalItens"
			hide-default-footer
			hide-default-header
			no-data-text=""
			class="my-5 mx-5 row-pointer"
		>
			<template #body="{ items }">
				<tbody class="m-5">
					<div style="display: grid; justify-content: space-evenly; grid-template-columns: 100%">
						<tr v-for="item in items" :key="item.id" style="margin-bottom: 10px" class="linha-tabela">
							<td class="py-2 table-adesoes-cell">
								<icone-tooltip
									v-if="item.adesaoExterna"
									icone="mdi-file-import-outline"
									cor="primary"
									texto="Adesão Pública"
									tamanho="20px"
								></icone-tooltip>

								<span class="item-text"> Adesão </span>

								<span class="minhas-adesoes-listagem__numero">
									{{ (item || {}).numero || '---' }}
								</span>

								<span class="minhas-adesoes-listagem__situacao">| {{ item.atividadeNome }} </span>

								<span
									v-if="isAdesaoEmTransito(item.atividadeSituacao)"
									class="minhas-adesoes-listagem__situacao"
									>| {{ item.atividadeSituacao }}
								</span>
							</td>
							<td class="py-2 table-adesoes-cell">
								<botao-tooltip
									v-az-auth="permissoes.ataAdesaoListar"
									icone="mdi-login"
									cor="grey"
									texto="Acessar"
									@click="acessar(item)"
								></botao-tooltip>
							</td>
							<td class="py-2 table-adesoes-cell">
								<menu-acoes
									v-if="
										validarSePodeExcluirAdesao(item.situacao) && !isAtaProrrogada && !isAtaCancelada
									"
									nome-botao=""
									nome="Manuseia Adesão"
									cor-de-fundo="grey"
									cor-icone="--v-anchor-base"
									icone-primary="mdi-dots-vertical"
									:acoes-menu="itensAcoes"
									@abrir-modal-exclusao-adesao="abrirModalExclusaoAdesao(item.id)"
								>
								</menu-acoes>
							</td>
						</tr>
					</div>
				</tbody>
			</template>
		</v-data-table>

		<template-listagem-vazia :total-itens="totalItens" :textos="objListagemVazia"></template-listagem-vazia>

		<paginacao-tabela
			v-if="hasItens"
			:page.sync="paginacaoInterna.page"
			:rows-per-page.sync="paginacaoInterna.rowsPerPage"
			:totalPaginas="totalPaginas"
			:totalItens="totalItens"
			@resetar-page="$emit('resetar-page')"
		></paginacao-tabela>
		<modal-confirmacao
			id="excluir-adesao-listagem"
			:exibir="exibirModalExclusaoAdesao"
			mensagem="Adesão será excluída e não poderá ser recuperada!"
			@fechar-modal="fecharModalExclusaoAdesao"
			@confirmar="excluirAdesao"
			:subtituloModal="'Deseja realmente excluir?'"
			tituloModal="Excluir Adesão"
		></modal-confirmacao>
	</div>
</template>

<script>
import { TabelaColunaUtils } from '@/core/utils'
import { actionTypes, permissoes, situacoes } from '@/core/constants'
import tabela from '@/views/mixins/tabela'
import situacaoFilter from '@/views/filters/situacao-filter'
import adesaoAta from '@/views/mixins/adesaoAta'
import ModalConfirmacao from '@/views/components/ModalConfirmacao.vue'
import validacaoAta from '@/views/mixins/validacaoAta'
import { mapState } from 'vuex'
import mutationTypes from '@/core/constants/mutation-types'

export default {
	name: 'acessar-minhas-adesoes-listagem',
	components: { ModalConfirmacao },
	mixins: [tabela, adesaoAta, validacaoAta],
	props: {
		itens: {
			type: Array,
			default: () => [],
		},
	},
	data() {
		return {
			exibirModalExclusaoAdesao: false,
			colunas: [
				new TabelaColunaUtils('Número', 'adesao', '90%', 'left'),
				new TabelaColunaUtils('Ações', 'acoes', '10%', 'right'),
			],
			objListagemVazia: {
				titulo: 'Nenhuma adesão por aqui',
			},
			paginacaoInterna: this.paginacao,
			itensAcoes: [
				{
					titulo: 'Excluir',
					icone: {
						nome: 'mdi-delete',
					},
					evento: 'abrir-modal-exclusao-adesao',
					authorization: permissoes.ataAdesaoExcluir,
				},
			],
			idAdesaoAExcluir: null,
		}
	},
	computed: {
		...mapState({
			informacoesAta: (state) => state.ata.informacoesAta,
			cabecalhoKey: (state) => state.comum.cabecalhoKey,
		}),
		isAtaProrrogada() {
			return this.informacoesAta && this.ehHistoricoProrrogacao(this.informacoesAta)
		},
		isAtaCancelada() {
			return this.estaCancelada(this.informacoesAta.situacao)
		},
	},
	methods: {
		async acessar(adesao) {
			await this.redirecionarParaAdesao(adesao.id, 'editar')
		},
		filtrarSituacaoAdesao(situacao) {
			return situacaoFilter(situacao, situacoes.ADESAO)
		},
		abrirModalExclusaoAdesao(idAdesao) {
			this.idAdesaoAExcluir = idAdesao
			this.exibirModalExclusaoAdesao = true
		},
		fecharModalExclusaoAdesao() {
			this.exibirModalExclusaoAdesao = false
			this.idAdesaoAExcluir = null
		},
		async excluirAdesao() {
			await this.$store.dispatch(actionTypes.ADESAO.EXCLUIR, { idAdesao: this.idAdesaoAExcluir })
			await this.$emit('recarregar-listagem-externa')

			this.mostrarNotificacaoSucesso('Adesão foi excluída com sucesso!')
			this.fecharModalExclusaoAdesao()
			this.atualizarCabecalho()
		},
		atualizarCabecalho() {
			this.$store.commit(mutationTypes.COMUM.SET_KEY_CABECALHO)
		},

		isAdesaoEmTransito(atividadeSituacao) {
			return atividadeSituacao === 'RECEBIDO' || atividadeSituacao === 'NÃO RECEBIDO'
		},
		validarSePodeExcluirAdesao(value) {
			if (value) {
				if (typeof value === 'string') {
					return (
						value === situacoes.ADESAO.EM_ELABORACAO.value ||
						value === situacoes.ADESAO.AGUARDANDO_ANALISE.value
					)
				}
				return (
					value.situacao === situacoes.ATA.EM_ELABORACAO.value ||
					value.situacao === situacoes.ADESAO.AGUARDANDO_ANALISE.value
				)
			}
			return false
		},
	},
}
</script>
<style lang="stylus" scoped>
.minhas-adesoes-listagem
	&__situacao
		color: var(--v-primary-base) !important
		font-weight bolder

	&__numero
		min-width 170px
		display inline-block
		text-align center


.linha-tabela
	border 1px solid #ccc
	border-radius 10px
	padding 0 12px

	.table-adesoes-cell
		width 100%
		padding 12px
</style>
